import { render, staticRenderFns } from "./CorrectionLog.vue?vue&type=template&id=2102fb52"
import script from "./CorrectionLog.vue?vue&type=script&lang=js"
export * from "./CorrectionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports